<div class="tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex tw-flex-col tw-gap-4 tw-shadow-card-item tw-rounded-2xl tw-p-4 sm:tw-px-3">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
      <span class="tw-font-semibold tw-text-color-text-default">
        {{ "amazonGiftCard" | i18n }} · AUD
      </span>
      <span
        class="tw-inline-flex tw-items-center tw-justify-center tw-h-[28px] tw-px-2 tw-rounded-full tw-bg-color-status-info-bg tw-text-[13px] tw-font-medium tw-leading-none tw-tracking-normal tw-text-color-status-info-text tw-whitespace-nowrap"
      >
        {{ "amazonGiftCardExchangeRate" | i18n: formattedRate() }}
      </span>
    </div>

    <!-- Denomination pills -->
    <div class="tw-flex tw-flex-wrap tw-gap-2">
      @for (amount of denominations; track amount) {
        <button
          type="button"
          (click)="selectDenomination(amount)"
          class="tw-w-[40px] tw-h-[28px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-[13px] tw-font-medium tw-border tw-transition-all"
          [ngClass]="
            !isCustom() && selectedAmount() === amount
              ? 'tw-bg-color-text-action tw-text-color-text-on-action tw-border-transparent'
              : 'tw-bg-color-surface-input tw-text-color-text-tertiary tw-border-color-chip-neutral-outline-border'
          "
        >
          ${{ amount }}
        </button>
      }

      <input
        type="number"
        [min]="minAmount"
        placeholder="{{ 'customAmount' | i18n }}"
        (focus)="selectCustom($event)"
        (input)="onCustomAmountChange($event)"
        class="tw-w-[56px] tw-h-[28px] tw-px-2 tw-text-center tw-rounded-full tw-text-[13px] tw-font-medium tw-border tw-transition-all"
        [ngClass]="
          isCustom()
            ? 'tw-bg-color-text-action tw-text-color-text-on-action tw-border-transparent'
            : 'tw-bg-color-surface-input tw-text-color-text-tertiary tw-border-color-chip-neutral-outline-border'
        "
      />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-1">
      <span class="tw-text-[13px] tw-font-medium tw-text-color-text-default">
        {{ "chooseAnAmount" | i18n }}
      </span>
      <span class="tw-text-[12px] tw-text-color-text-tertiary">
        {{ "amazonGiftCardAmountHint" | i18n: formattedAmount() : formattedPoints() }}
      </span>
    </div>

    <div
      class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-rounded-xl tw-bg-color-surface-sunken tw-p-4 sm:tw-px-2"
    >
      <div class="tw-flex tw-items-center tw-gap-2">
        <icon [size]="6" [name]="'gift'" [currentColor]="'color-action-primary'"></icon>
        <span class="tw-font-semibold tw-text-color-text-default">
          {{ "cashBack" | i18n }} · {{ "amazonGiftCard" | i18n }}
        </span>
      </div>

      <button
        type="button"
        (click)="redeem()"
        [disabled]="!isRedeemable()"
        class="tw-shadow-button-bg tw-flex tw-flex-row tw-justify-center tw-items-center tw-w-[120px] tw-h-[48px] tw-rounded-full tw-bg-gradient-teal tw-text-color-text-on-action tw-font-semibold disabled:tw-opacity-50"
      >
        <span class="tw-uppercase tw-text-sm">{{ "redeem" | i18n }}</span>
      </button>
    </div>
  </div>
</div>
